import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Form, Row, Col, Container } from 'react-bootstrap';

import { StateFormGroup } from '../FormFields/StateFormGroup';
import { installationSchema } from '../../schemas/installationAddressSchema';
import { ControlButtons } from '../ControlButtons';

export const InstallationAddress = ({
	currInstallationAddr = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const { register, handleSubmit, formState } = useForm({
		resolver: yupResolver(installationSchema),
		defaultValues: currInstallationAddr,
	});

	return (
		<Container className="component">
			<Container className="p-0 mt-5 component">
				<h2 className="mt-3">Installation Address</h2>
				<Container className="mt-3 p-0">
					<Form.Group className="mb-3">
						<Form.Label>Street</Form.Label>
						<Form.Control
							className="StreetInput"
							type="text"
							{...register('street')}
						/>
						<Form.Text className="text-danger">
							{formState.errors.street?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>City</Form.Label>
						<Form.Control
							className="CityInput"
							type="text"
							{...register('city')}
						/>
						<Form.Text className="text-danger">
							{formState.errors.city?.message}
						</Form.Text>
					</Form.Group>
					<Row className="mb-3">
						<Form.Group as={Col}>
							<StateFormGroup
								register={register}
								error={formState.errors}
								value={currInstallationAddr.state}
							/>
						</Form.Group>
						<Form.Group as={Col}>
							<Form.Label>ZIP Code</Form.Label>
							<Form.Control
								className="ZIPInput"
								type="text"
								{...register('zip')}
							/>
							<Form.Text className="text-danger">
								{formState.errors.zip?.message}
							</Form.Text>
						</Form.Group>
					</Row>
				</Container>
			</Container>

			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={handleSubmit(onSubmit)}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}
			/>
		</Container>
	);
};
